export const removeSlash = (text) => text.replace(/\//g, '');
